import { render, staticRenderFns } from "./eduCard.vue?vue&type=template&id=baadf63a&scoped=true&"
import script from "./eduCard.vue?vue&type=script&lang=js&"
export * from "./eduCard.vue?vue&type=script&lang=js&"
import style0 from "./eduCard.vue?vue&type=style&index=0&id=baadf63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baadf63a",
  null
  
)

export default component.exports